<script setup lang="ts">
const swiper = useSwiper()
</script>

<template>
	<div class="swiper-nav">
		<button class="swiper-nav__btn swiper-nav__btn--left" @click="swiper.slidePrev()">
			<GlobalIcon name="arrow-left" :height="20" />
		</button>
		<button class="swiper-nav__btn swiper-nav__btn--right" @click="swiper.slideNext()">
			<GlobalIcon name="arrow-right" :height="20" />
		</button>
	</div>
</template>

<style lang="scss" scoped>
@import './SwiperNav';
</style>
